import { createFileRoute } from '@tanstack/react-router'
import { SharedMedicalHistoryPage } from '_/features/pets/ui/pages/shared-medical-history-page'

const ShareRoute = () => {
	const { token } = Route.useParams()
	return <SharedMedicalHistoryPage token={token} />
}

// Deliberately outside _authenticated (and _auth): whoever opens this link
// has no account, so it must never be gated behind AuthGuard.
export const Route = createFileRoute('/share/$token')({
	staticData: { title: 'medical_history_title' },
	component: ShareRoute,
})
